import React from 'react';

const RotaNaoEncontrada = () => {
    return (
        <div>
            404 - Endereço inválido
        </div>
    );
};

export default RotaNaoEncontrada;